import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import SetTitle from "../../utils/set_title";
import {BASE_URL} from "../../utils";
import Header from '../../components/Headers/Header'



export default function KeywordClusteringFile() {
	SetTitle('Keyword Clustering')
	const params = useParams()

	useEffect(() => {
    	downloadData()
  	}, [])

	const downloadData = () => {
		if (params?.id) {
			setTimeout(() => {
				window.location.href = BASE_URL+'/api/1/get-keyword-clustering/'+params.id
				setTimeout(() => {
					window.location.href = '/keyword-clustering'
				}, 5000)
			}, 1000)
		}
		else {
			setTimeout(() => {
				window.location.href = '/keyword-clustering'
			}, 1000)
		}
	}

	return (
		<Header
			iconClass="ni ni-folder-17 text-white"
			title="Keyword Clustering"
			description="Download in corso..."
		/>
	)
}
